import i18 from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import englishTranslations from './locales/en.json';
import arabicTranslations from './locales/ar.json';

i18
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    supportedLngs: ['en', 'ar'],
    resources: {
      en: {
        translation: englishTranslations
      },
      ar: {
        translation: arabicTranslations
      }
    }
  });

export default i18;
